export default __webpack_public_path__ + "static/harvest-hush-logo-small-ef71e13d8fbf0668eda10867c32a5beb.svg";